<div layout class="lg-down-flex-wrap">
  <div *ngFor="let day of days"
       class="days-range pointer"
       [ngClass]="{'day-selected': day.selected, 'day-disabled': day.disabled, 'day-error': !day.disabled && isNotValid}"
       (click)="changeSelection(day)">
    {{ day.label | translate }}
  </div>
</div>
<span *ngIf="isNotValid" class="error-msg" >{{'LEAD_GENERATION.SETTINGS.RANGE_DAY_ERROR' | translate}}</span>
